import Query from '../utils/Query';
import Page from "../models/Page";

const defaultFields = '*,created_by.*,created_by.avatar.private_hash,columns.*';

export default class DatasetService {

	static getAll(id) {
		return Query.get('/items/dataset' + (id ? '?filter[created_by]=' + id + '&fields=' + defaultFields : ''));
	}

	static getByUser(userId) {
		return Query.get('/items/dataset?fields=' + defaultFields + '&filter[created_by]=' + userId);
	}

	static getColumns(datasetId) {
		return Query.get('/items/dataset_column?filter[dataset]=' + datasetId);
	}

	static getRows(datasetId) {
		return Query.get('/items/dataset_row?filter[dataset]=' + datasetId);
	}

	static getCellStats(userId, limit = 1000) {
		return Query.get('/activity', {
			fields: 'action,item,action_on',
			filter: {
				action_by: userId,
				action: {
					in: 'insert,create'
				},
				collection: 'dataset_cell',
			},
			limit,
		});
	}

	static get(id, includeData = false, revisionOffset) {

		let suffix = '';
		if (includeData) {
			suffix += '?fields=*,columns.*,rows.*,rows.cells.*,rows.created_by.*,rows.created_by.avatar.private_hash';
		}

		return Query.get('/items/dataset/' + id + (revisionOffset !== undefined ? '/revisions/' + revisionOffset : '') + suffix);
	}

	static getRevisions(id) {
		return Query.get('/items/dataset/' + id + '/revisions?limit=25&fields=*,activity.action_by.first_name,activity.action_by.last_name,activity.action_by.screen_name,activity.action_by.avatar.private_hash');
	}

	static fork(revisionId) {
		return Query.post('/custom/dataset/fork/' + revisionId);
	}

	static save(transactions = []) {
		return Query.post('/custom/transaction/run', transactions, undefined, false);
	}

	static remove(id) {
		return Query.delete('/items/dataset/' + id);
	}
}
